<template>
    <div class="columns is-multiline is-centered p-4">
        <div
            class="
                column
                is-offset-6 is-6 is-inline-flex is-justify-content-center
            "
        >
            <div class="field has-addons">
                <div class="control">
                    <DatePicker
                        v-model="date"
                        minDate="29/08/2022"
                        :maxDate="maxDate"
                        :remove="false"
                    />
                </div>
                <div class="control ml-4">
                    <input
                        type="text"
                        class="input is-radiusless"
                        v-model="filters.search"
                        @keydown.enter="refreshFilters"
                    />
                </div>
                <div class="control">
                    <button
                        class="button is-primary is-radiusless"
                        @click="refreshFilters"
                    >
                        <Icon family="fal" name="fa-search" />
                    </button>
                </div>
                <div class="control">
                    <button
                        class="button is-primary ml-3"
                        @click="downloadReport"
                        :disabled="isDownloading || items.length === 0"
                    >
                        <Icon family="fal" name="fa-download" />
                    </button>
                </div>
            </div>
        </div>
        <div class="column is-11 has-text-centered" v-if="isLoading">
            <h5 class="has-text-primary has-text-weight-bold">
                Se esta cargando la información ...
            </h5>
            <Loading />
        </div>
        <div class="column is-11 is-inline-flex" v-else>
            <table class="table is-striped is-hoverable is-fullwidth">
                <thead class="is-size-7">
                    <tr>
                        <th>Fecha y Hora</th>
                        <th>Estado</th>
                        <th>Operador</th>
                        <th>Email Operador</th>
                        <th>Cédula</th>
                        <th>Nombre</th>
                        <th>Email</th>
                        <th>Trámite</th>
                        <th>Tiempo de Espera</th>
                        <th>Tiempo en llamada</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, idx) in items">
                        <tr :key="idx">
                            <td>{{ row.creationDate }}</td>
                            <td>{{ row.status }}</td>
                            <td>{{ row.operatorName }}</td>
                            <td>{{ row.operatorEmail }}</td>
                            <td>{{ row.userCedula }}</td>
                            <td>{{ row.userName }}</td>
                            <td>{{ row.userEmail }}</td>
                            <td>{{ row.skill }}</td>
                            <td>{{ row.waitingTime }}</td>
                            <td>{{ row.onCallTime }}</td>
                        </tr>
                    </template>
                    <tr v-if="totalPages === 0">
                        <td align="center" colspan="12">No hay registros...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            v-if="totalPages > 1"
            class="column is-11 is-inline-flex is-justify-content-flex-end"
        >
            <nav class="pagination" role="navigation">
                <a
                    class="pagination-previous"
                    v-if="currentPage > 1"
                    v-on:click="prev()"
                    >Anterior</a
                >
                <a
                    class="pagination-previous"
                    v-if="currentPage < totalPages"
                    v-on:click="next()"
                    >Siguiente</a
                >

                <ul class="pagination-list">
                    <li v-if="currentPage > 2">
                        <a class="pagination-link" @click="goto(1)">1</a>
                    </li>

                    <li v-if="currentPage > 3">
                        <span class="pagination-ellipsis">&hellip;</span>
                    </li>
                    <li v-if="currentPage > 1">
                        <a
                            class="pagination-link"
                            v-on:click="goto(currentPage - 1)"
                            >{{ currentPage - 1 }}</a
                        >
                    </li>
                    <li>
                        <a
                            class="pagination-link is-current"
                            v-on:click="goto(currentPage)"
                            >{{ currentPage }}</a
                        >
                    </li>
                    <li v-if="totalPages > currentPage">
                        <a
                            class="pagination-link"
                            v-on:click="goto(currentPage + 1)"
                            >{{ currentPage + 1 }}</a
                        >
                    </li>
                    <li v-if="totalPages - currentPage > 2">
                        <span class="pagination-ellipsis">&hellip;</span>
                    </li>

                    <li v-if="totalPages - currentPage > 1">
                        <a
                            class="pagination-link"
                            v-on:click="goto(totalPages)"
                            >{{ this.totalPages }}</a
                        >
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";

import moment from "moment";
import Loading from "@/components/Loading.vue";
import DatePicker from "@/components/external-components/datepicker/DatePicker";

export default {
    name: "base-report",
    components: {
        Loading,
        DatePicker,
    },
    data() {
        return {
            isLoading: true,
            items: [],
            currentPage: 1,
            totalPages: 0,

            maxDate: null,
            date: null,
            filters: {
                page: 1,
                take: 10,
                search: "",
            },

            isDownloading: false,
        };
    },
    mounted() {
        var today = moment().format("DD/MM/YYYY");
        this.date = today;
        this.maxDate = today;
    },
    watch: {
        date() {
            this.getItems();
        },
    },
    methods: {
        async getItems() {
            this.isLoading = true;
            try {
                let date = moment(this.date, "DD/MM/YYYY").format(
                    "YYYY-MM-DDTHH:mm:ss"
                );
                let payload = {
                    page: this.filters.page,
                    take: this.filters.take,
                    search: this.filters.search,
                    date: date,
                };
                var response = await RepositoryFactory.reports.getReportBase(
                    payload
                );
                let items = response.data.items;
                items = this.parseItems(items);
                this.items = items;
                this.totalPages = response.data.pages;
            } catch (error) {
                window.console.log(error);
            }
            this.isLoading = false;
        },
        parseItems(items) {
            for (const item of items) {
                item.status = this.getStatus(item.status);
                item.creationDate = this.formatDate(item.creationDate);
                item.waitingTime = this.parseTime(item.waitingTime);
                item.onCallTime = this.parseTime(item.onCallTime);
            }
            return items;
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY hh:mm A");
        },
        parseTime(time) {
            if (time === null) {
                return "-";
            }
            return time.split(".")[0];
        },
        getStatus(status) {
            switch (status) {
                case 0:
                    return "En cola";
                case 1:
                    return "Atendida";
                case 2:
                    return "Abandonada";
            }
            return "";
        },
        refreshFilters() {
            this.currentPage = 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        goto(page) {
            this.currentPage = page;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        prev() {
            this.currentPage = this.currentPage - 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        next() {
            this.currentPage = this.currentPage + 1;
            this.filters.page = this.currentPage;
            this.getItems();
        },
        async downloadReport() {
            this.isDownloading = true;

            try {
                let date = moment(this.date, "DD/MM/YYYY").format(
                    "YYYY-MM-DDTHH:mm:ss"
                );
                let payload = {
                    search: this.filters.search,
                    date: date,
                };
                var response =
                    await RepositoryFactory.reports.downloadReportBase(payload);

                let csvContent = `data:text/csv;charset=utf-8,${response.data}`;
                var encodedUri = encodeURI(csvContent);
                var link = document.createElement("a");
                link.setAttribute("href", encodedUri);
                link.setAttribute("download", `Report ${this.date}.csv`);
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                window.console.log(error);
            }

            this.isDownloading = false;
        },
    },
};
</script>